import angular from "angular";
import notify from "@cgross/angular-notify";

angular
    .module('core.notifier', [notify])
    .service('notifier', ['notify', function (notify) {

        this.errorResponseNotify = function (error, duration) {
            let messageTemplate = '';
            if (error.data.messages) {
                error.data.messages.forEach(function (m) {
                    messageTemplate += m + '<br>';
                });
            } else {
                messageTemplate = 'Undefined error message';
            }
            return this.errorNotify(messageTemplate, duration);
        };

        this.errorNotify = function (content, duration) {
            return notify({
                messageTemplate: '<div>' + content + '</div>',
                classes: 'alert-danger',
                duration: duration || null
            });
        };

        this.successNotify = function (message, duration) {
            return notify({
                messageTemplate: '<div>' + message + '</div>',
                classes: 'alert-success',
                duration: duration || 0
            });
        }

    }]);

export default 'core.notifier';


// WEBPACK FOOTER //
// ./resources/assets/modules/core/notifier.service.js